import { render, staticRenderFns } from "./el-table-edit.vue?vue&type=template&id=0c1314fe"
import script from "./el-table-edit.vue?vue&type=script&lang=js"
export * from "./el-table-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports